import { useRepositories } from "../../../contexts";
import { LoaderType, useAppMutation } from "../utils";
export var useVerifyCodeApi = function (loaderType) {
    if (loaderType === void 0) { loaderType = LoaderType.FullPage; }
    var authRepo = useRepositories().authRepo;
    return useAppMutation(function (params) {
        return authRepo.verifyCode(params);
    }, {}, loaderType);
};
